import { JobStatus } from "pages/crawler/components/jobs/types";
import { StatusBadge as BaseStatusBadge } from "components/StatusBadge";
import { formatStatusDisplay, isStatusRunning } from "pages/crawler/utils/crawlerStatusUtils";

export const StatusBadge = ({
  status,
  scheduledTime,
}: {
  status: JobStatus | any; // Allow both old string and new object format
  scheduledTime?: string;
}) => {
  const { label, color, state } = formatStatusDisplay(status);
  const text = state === "scheduled" && scheduledTime ? `Scheduled in ${scheduledTime}` : label;

  return <BaseStatusBadge label={text} color={color} spinner={isStatusRunning(status)} />;
};

export default StatusBadge;
